import React from 'react';

import { Navigate } from 'react-router';

import useAuthorization from 'hooks/use_authorization';

import { MATCH_TYPES } from './match_types';

type AuthorizationProps = {
  children: React.ReactNode;
  /** `'all'` requires every permission; `'any'` requires one. @defaultValue MATCH_TYPES.ALL */
  matchType?: (typeof MATCH_TYPES)[keyof typeof MATCH_TYPES];
  /** Permission(s) the user must NOT have. */
  notTo?: string | string[];
  /** Redirect target for unauthorized users; renders nothing if unset. */
  redirectPath?: string;
  /** Permission(s) the user must have. */
  to?: string | string[];
};

function Authorization({
  children,
  matchType = MATCH_TYPES.ALL,
  notTo,
  redirectPath,
  to,
}: AuthorizationProps) {
  const isAuthorized = useAuthorization({ matchType, notTo, to });

  if (isAuthorized) {
    return children;
  }

  return redirectPath ? <Navigate to={redirectPath} /> : null;
}

export default Authorization;
